export default {
  // 初始提示文本
  initialPrompt: "雙擊節點可按選擇的交易方向擴展相關的交易地址",
  // 多選方法說明
  multiSelectMethod:
    "多選方法：1、ctrl/⌘+滑鼠左鍵選擇多個節點。2、滑鼠右鍵框選多個節點",
  // 節點類型提示
  node: {
    prompts: [
      "雙擊節點可按選擇的交易方向擴展相關的交易地址",
      "可選擇一個或多個節點，可點擊頂部或右側操作區的按鈕體驗更多功能",
      "可通過操作（ctrl+E/⌘+E）快捷鍵或打開左側展開詳情按鈕查看節點詳情",
    ],
  },
  // 邊類型提示
  edge: {
    prompts: [
      "可通過操作（ctrl+E/⌘+E）快捷鍵或打開左側展開詳情按鈕查看交易詳情",
    ],
  },
  // 多節點類型提示
  morenode: {
    prompts: [
      "可點擊頂部或右側操作區的按鈕體驗更多功能",
      "按回車鍵可快速批量擴展地址交易信息",
    ],
  },
};
